import { styled } from 'theme';

const Icon = styled('svg', {
  // Reset
  verticalAlign: 'middle',

  // Custom
  display: 'inline-block',
  flexShrink: 0,
  fill: 'currentcolor',

  variants: {
    variant: {
      circleBg: {
        p: '$1',
        borderRadius: '$full',
        backgroundColor: '$secondary',
        color: '$white',
      },
    },
  },
});

export default Icon;
